import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant'
import 'vant/lib/index.css'
import 'amfe-flexible'
import dataV from '@jiaminghi/data-view'
import Color from '@/style/color.scss' // 引入主scss变量
import hls from 'videojs-contrib-hls'
import Http from './service/request.js'
import { wexinShare, hideShare, getCode, isWechatOrAlipayBrowser, pcNextHanlde, isIos, mainWebsite, refreshShare } from '@/utils/wechatJsSdk'
import VerifyIdentity from '@/utils/VerifyIdentity.js'
import { GetParam, buildUrl } from '@/utils/getParam.js'
import { getGuestId, getLogin, loginAsGuest } from '@/api/info'
import { setStore } from '@/utils/setStore'
import navigateBack from '@/utils/navigate'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import weekOfYear from 'dayjs/plugin/weekOfYear'
import 'dayjs/locale/zh-cn'
moment.locale('zh-cn')
import { Lazyload } from 'vant'
import moment from 'dayjs'
moment.extend(isSameOrBefore)
moment.extend(isSameOrAfter)
moment.extend(weekOfYear)

import VueLuckyCanvas from '@lucky-canvas/vue'
Vue.use(VueLuckyCanvas)
Vue.use(dataV)
Vue.prototype.$Http = Http // 把Http挂载到vue 实例上  全局都可以用
Vue.prototype.$setvuex = setStore // 把Http挂载到vue 实例上  全局都可以用
Vue.use(hls) // 要播放hls流,
Vue.prototype.$imgurl = process.env.VUE_APP_IMG_URL
Vue.prototype.$Color = Color // 将scss变量挂载到全局
Vue.prototype.$VerifyIdentity = VerifyIdentity // 将scss变量挂载到全局
Vue.prototype.$navigateBack = navigateBack // 将scss变量挂载到全局
Vue.prototype.$moment = moment
Vue.prototype.$wexinShare = wexinShare
Vue.prototype.$hideShare = hideShare

Vue.config.productionTip = false
Vue.use(Vant)
Vue.use(Lazyload)
Vue.config.ignoredElements = ['wx-open-subscribe', 'wx-open-launch-weapp']

router.afterEach((to, from) => {
  // sendToAnalytics(to.fullPath)
  // WeChat PC/移动端在单页应用中需要在路由变化后刷新分享配置，保证 link 为当前地址
  const ua = navigator.userAgent || ''
  if (/MicroMessenger/i.test(ua)) {
    // 可根据路由元信息选择性跳过
    if (to.meta && to.meta.share !== false) {
      refreshShare()
    }
  }
})
router.beforeEach(async (to, from, next) => {
  // 当分享链接为根路径并带有 `path` 参数时，优先还原到目标路由
  if (to.query && to.query.path) {
    try {
      const target = decodeURIComponent(to.query.path)
      if (typeof target === 'string' && target.length > 0) {
        // 避免循环：如果已经在目标路由则不再跳转
        const withoutHash = target
        if (to.fullPath !== withoutHash) {
          next(withoutHash)
          return
        }
      }
    } catch (e) {
      // 解码失败则继续原流程
    }
  }
  // 缓存当前路径到sessionStorage
  sessionStorage.setItem('currentPath', to.fullPath)

  if (mainWebsite(to, from, next) === true) {
    return
  }
  pcNextHanlde(to, from, next)

  // 默认标题
  document.title = process.env.VUE_APP_NAME
  if (to.meta.title) {
    document.title = to.meta.title
  }

  // 在main.js里判断是否是ios和vuex保存的这个url是否为空，为空则存入当前url：
  if (isIos() && store.state.wxSignUrl == '') {
    store.commit('setWechatSignUrl', process.env.VUE_APP_BASE_Url + to.fullPath)
  }

  const token = store.state.token

  if (to.query.next === 'pc' || globalGetQueryParam('next') === 'pc') {
    next()
    return
  }
  if (isWechatOrAlipayBrowser() && to.path == '/goodDetails') {
    // 从首页，商品列表也，分类页，收藏夹，商家详情点击进入商品详
    // const routerList = []
    if (from.name !== null) {
      // 查询是是否登錄
      if (store.state.userInfo?.unionid) {
        next()
      } else {
        // 記錄要去的路由
        setStore('toPageUrl', to.fullPath)
        setStore('longDialogShow', true)
        return
      }
    }
  }
  // 已登录
  if (token) {
    next()
    return
  } else if (to.path == '/settoken') {
    next()
    return
  }
  // 未登录且不是微信和支付宝浏览器（PC） || 开发地址
  else if (!token && !(isWechatOrAlipayBrowser())) {
    setStore('token', '');
    setStore('userInfo', {});

    const guestId = to.query.guestId;
    const guestLogin = to.query.guestLogin;

    const handleGuestLogin = (credentials) => {
      getGuestId(credentials).then((res1) => {
        if (res1.code === 200) {
          loginAsGuest({ guestId: res1.data }).then((res2) => {
            if (res2.code === 200) {
              setStore("token", res2.data.token);
              setStore("userInfo", res2.data.user);

              // 清除URL中的登录参数，避免刷新时重复登录
              const cleanUrl = buildUrl(window.location.origin + to.fullPath)
              window.history.replaceState({}, document.title, cleanUrl)

              // 登录成功后继续路由导航
              next();
            } else {
              console.error('游客登录失败');
              // 登录失败也需要继续，否则页面会卡住
              next();
            }
          }).catch(() => {
            console.error('游客登录异常');
            next();
          });
        } else {
          console.error('获取游客ID失败');
          // 失败也需要继续路由
          next();
        }
      }).catch(() => {
        console.error('获取游客ID异常');
        next();
      });
    };

    if (guestLogin) {
      handleGuestLogin({ password: guestLogin });
    } else if (guestId) {
      handleGuestLogin({ guestId: guestId });
    } else {
      setStore('longDialogShowPC', true);
      // 显示登录弹窗后继续路由
      next();
    }

    // 移除这里的next()，改为在异步回调中执行
    return;
  }


  // 未登录
  const query = GetParam()
  if (!query.code) {
    // 检查授权类型
    const authType = localStorage.getItem('authType')

    // 首次访问：使用静默授权（snsapi_base）
    if (!authType) {
      localStorage.setItem('authType', 'base')

      // 防止重复跳转
      const isRedirecting = sessionStorage.getItem('isRedirectingToAuth')
      if (isRedirecting) {
        console.warn('正在跳转授权页面，跳过重复请求')
        return
      }
      sessionStorage.setItem('isRedirectingToAuth', 'true')

      // 静默授权，用户无感知
      const href = buildUrl(window.location.origin + to.fullPath)
      getCode(href, 'snsapi_base')
      return
    }

    // 需要显式授权（之前静默授权失败或已经是userinfo类型）
    if (authType === 'userinfo') {
      setStore('longDialogShow', true)
      setStore('toPageUrl', to.fullPath)
      next()
      return
    }

    // authType === 'base' 但没有token
    // 说明静默授权后登录可能失败了，需要升级为显式授权
    localStorage.setItem('authType', 'userinfo')
    setStore('longDialogShow', true)
    setStore('toPageUrl', to.fullPath)
    next()
    return
  } else {
    // 授权回调，清除跳转标记
    sessionStorage.removeItem('isRedirectingToAuth')
    // 防止重复请求：检查是否正在处理登录
    if (store.state.isLoggingIn) {
      console.warn('登录请求正在处理中，跳过重复请求')
      return
    }

    const data = {
      code: query.code,
      source: 'ZHQQ',
      scope: query.state,
      access: query.access ? query.access : 'SELF'  // 自己平台(默认，可不传)：SELF，中山通：ZST
    }

    // 调试日志：打印登录参数
    console.log('[登录调试] code:', query.code, ', URL:', window.location.href)

    // ✅ 关键修复：立即清除URL中的code参数，防止路由守卫再次执行时重复使用
    const cleanUrl = buildUrl(window.location.origin + to.fullPath)
    window.history.replaceState({}, document.title, cleanUrl)

    // 设置登录中状态
    store.commit('setIsLoggingIn', true)

    // 下面是我根据我实际业务场景编写的，主要是根据code获取个人信息保存。授权登录走到这一步基本就做完了
    await getLogin(data).then(res => {
      if (res.code == 200) {
        // 登录成功，清除计数器和登录状态
        setStore('codeSUM', 0)
        store.commit('setIsLoggingIn', false)

        // 保存所有用户信息和token
        setStore('token', res.data.token)
        setStore('userInfo', res.data.user)
        setStore('openid', res.data.wechat.id)


        // 保持当前授权类型（base或userinfo）
        const currentAuthType = localStorage.getItem('authType') || 'base'
        localStorage.setItem('authType', currentAuthType)


        // 处理新用户和普通用户
        if (res.data.base_newuser && to.name != 'Home' && to.name != 'shop') {
          setStore('longDialogShow', true)
          setStore('toPageUrl', to.fullPath)
        } else {
          setStore('setTabbarShow', true)
          setStore('longDialogShow', false)
        }

        // 使用setTimeout确保store状态更新后再调用next()
        setTimeout(() => {
          next()
        }, 0)
      } else {
        // 登录失败处理
        store.commit('setIsLoggingIn', false)
        const currentCount = store.state.codeSUM + 1
        setStore('codeSUM', currentCount)

        if (res.code == 401) {
          setStore('token', '')
          setStore('userInfo', {})
          setStore('openid', '')
          localStorage.removeItem('token')
          localStorage.removeItem('userInfo')
          localStorage.removeItem('openid')

          // 检查当前授权类型
          const authType = localStorage.getItem('authType')

          // 如果是静默授权返回401，升级为显式授权
          if (authType === 'base') {
            console.warn('静默授权失败（401），升级为显式授权')
            localStorage.setItem('authType', 'userinfo')
            setStore('longDialogShow', true)
            setStore('toPageUrl', to.fullPath)
            next()
            return
          }
        }

        // 请求失败重试机制：最多重试1次，添加延迟避免频繁请求
        if (currentCount <= 1) {
          console.warn(`登录失败，将在2秒后重试 (${currentCount}/1)`)
          setTimeout(() => {
            // 清除URL中的旧code参数后再重新获取
            const cleanUrl = buildUrl(window.location.origin + to.fullPath)
            getCode(cleanUrl, query.scope)
          }, 2000)
        } else {
          // 达到重试上限，重置计数器并提示用户
          setStore('codeSUM', 0)
          console.error('登录失败次数过多，请稍后重试')
          // 清除URL中的code参数
          const cleanUrl = buildUrl(window.location.origin + to.fullPath)
          window.history.replaceState({}, document.title, cleanUrl)
          // 显示登录弹窗，让用户重新登录
          setStore('longDialogShow', true)
          setStore('toPageUrl', to.fullPath)
          next()
        }
      }
    }).catch((error) => {
      // 网络错误或其他异常
      store.commit('setIsLoggingIn', false)
      const currentCount = store.state.codeSUM + 1
      setStore('codeSUM', currentCount)

      console.error('登录请求异常:', error)

      if (currentCount <= 1) {
        console.warn(`登录异常，将在2秒后重试 (${currentCount}/1)`)
        setTimeout(() => {
          const cleanUrl = buildUrl(window.location.origin + to.fullPath)
          getCode(cleanUrl, query.scope)
        }, 2000)
      } else {
        setStore('codeSUM', 0)
        console.error('登录失败次数过多，请稍后重试')
        const cleanUrl = buildUrl(window.location.origin + to.fullPath)
        window.history.replaceState({}, document.title, cleanUrl)
      }
    }).catch(() => {
       if (store.state.codeSUM < 3) {
          getCode(href, query.scope)
        } else {
          setStore('codeSUM', 0)
        }
    })
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
